import {t} from '@/core/utils/t'

window.t = t
